import { useState, useEffect, useContext } from "react"
import useWindowDimensions from "@hooks/useWindowDimensions"
import useMountObserver from "@hooks/useMountObserver" 
import { BlackAndWhiteLayoutContext } from "../../../Common/Layout/Black-White/Context"
import { isEmpty } from "../../../../helpers"
import { containsCurrentCategory } from "../../helpers"

const useBlogConfiguration = (edges, categories) => {
  const {
    articleCategories,
    selectedFilterOption,
    setSelectedFilterOption,
    setArticleCategories,
    openMobileFiltersSection,
  } = useContext(BlackAndWhiteLayoutContext)
  const { isMounted } = useMountObserver();
  const { isDesktop, isTablet, isMobile } = useWindowDimensions()
  const [filteredOptions, setFilteredOptions] = useState([])

  const sortByDate = (articles) => articles?.sort((x, y) => new Date(y.node.date) - new Date(x.node.date));
  console.log(edges)
  useEffect(() => {
    !!selectedFilterOption ? 
    setFilteredOptions(edges?.filter(({ node: { categories } }) => containsCurrentCategory(selectedFilterOption, categories)))
    : 
    setFilteredOptions(edges)
  }, [selectedFilterOption])

  useEffect(() => {
   if(isEmpty(articleCategories)) {
    setArticleCategories(categories?.allStrapiCategories?.edges?.filter(({ node: { order } }) => Boolean(order)));
   }
  }, [])

  return {
    isMounted,
    isDesktop,
    isTablet,
    isMobile,
    selectedFilterOption,
    filteredOptions: sortByDate(filteredOptions),
    setSelectedFilterOption,
    openMobileFiltersSection,
  }
}

export default useBlogConfiguration
